import styled from 'styled-components';

export const DivStyledVideoContainer = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: 0;
  }
`;
